import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMeetingCamera = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-0.5 -0.5 25 25",
	width: "1em",
	height: "1em",
	style: {
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	},
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .75,
		y: 5.261,
		width: 15,
		height: 13.5,
		rx: 3,
		ry: 3
	}), /* @__PURE__ */ _jsx("path", { d: "M18.75,15.011l3.415,1.707a.75.75,0,0,0,1.085-.671V7.974a.749.749,0,0,0-1.085-.67L18.75,9.011" })]
});
export default SvgMeetingCamera;
